import React, { Component } from 'react';
import cookie from 'react-cookies';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { Button, Col, Form, Input, InputGroup, FormFeedback, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import FormLayout from 'containers/FormLayout';
import { login } from 'store/auth/actions';
import { AppNavbarBrand } from '@coreui/react';
import logo from 'assets/img/brand/stepapp_logo.png';
import { message, Checkbox, Spin } from 'antd';
var CryptoJS = require("crypto-js");


const mapStateToProps = (state) => {
    console.log(state);
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (payload) => {
            dispatch(login(payload))
        }
    }
}

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mobile: '',
            password: '',
            rememberMechk: false,
            showOtpFlag: false,
            signLoader: false,
        };

        this.login = this.login.bind(this);
        this.onUpdateFormValue = this.onUpdateFormValue.bind(this);

    }

    Loginerror = (errMsg) => {
        const alert = this.props.alert;     
        alert.error(errMsg)
        // message.error(errMsg);
    };

    Loginsuccess = () => {
        message.success('Login Successful !!');
    };

    onUpdateFormValue(e) {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        });
    }

    onRememberChk = (e) => {

        this.setState({
            rememberMechk: e.target.checked
        }, () => {
            console.log(this.state.rememberMechk)
        })
    }

    async login() {
        try {

            let mobile = this.state.mobile;
            let password = this.state.password;
            let rememberMechk = this.state.rememberMechk
            let loginDate = new Date();
            let expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 14);
            console.log(expiryDate);

            let errorMsg = "";

            let usrencrpt = CryptoJS.AES.encrypt(mobile, '12345').toString();
            let passencrpt = CryptoJS.AES.encrypt(password, '12345').toString();

            if (mobile !== '' && password !== '') {
                const result = await window.$http.post('login/userlogin', {
                    usermobile: this.state.mobile,
                    otp: this.state.password
                });

                if (result.status === "success") {
                    if (rememberMechk === true) {
                        localStorage.setItem('usr', usrencrpt);
                        localStorage.setItem('pas', passencrpt);
                        localStorage.setItem('loginDate', loginDate);
                        localStorage.setItem('expiryDate', expiryDate);
                    }
                    localStorage.setItem('login_data', JSON.stringify(result));

                    const { user, role ,school,board } = result.data;

                    console.log(result);
                    console.log(result.data.school.school_id);
                    console.log(result.data.board.board_id);

                    // Save user in redux
                    this.props.login({
                        firstName: user.first_name,
                        lastName: user.last_name,
                        role: role,
                        schoolId: school.school_id,
                        boardId: board.board_id,
                    });

                    if (role === "school") {
                        this.props.history.push('/principal');
                    }
                } else {
                    errorMsg = "Incorrect Username or Password !!"
                    this.Loginerror(errorMsg);

                    this.setState({
                        mobile: '',
                        password: ''
                    })

                }
            } else {
                errorMsg = "Please enter correct username and password !!"
                this.Loginerror(errorMsg)
            }
        } catch (err) {
            window.$utility.showMessage('error', err.message);
        }
    };

    onKeyDown = (event) => {   
        if (event.key === 'Enter' || event.keyCode === 13) { 
            event.preventDefault();          
            event.stopPropagation();        
            this.login();      
        }    
    }

    // --------------------------------------------

        onRememberChk = e => {     
            this.setState({ rememberMechk: e.target.checked })  
                    if ( e.target.checked === true) {      
                     //    user wants to be remembered.
                          this.rememberUser();       
                          } else {     
                          this.forgetUser();     
                 }    
             }
                   
             
     rememberUser =  () => {  
         let mobile = this.state.mobile;        
         let password = this.state.password;    
         cookie.save('userId', mobile)          
         cookie.save('password', password)  
     };
 
     getRememberedUser =  () => {
         const username =  cookie.load('userId');     
         if (username   !== null) {              
         return username;       
         }               
         };               
     getRememberedPassword =  () => {      
         const password =  cookie.load('password');    
         if (password !== null) {                
         return password;         
         }                     
     };
 
     forgetUser =  () => {          
         cookie.remove('userId');           
         cookie.remove('password');                
     };
 
 //===========================================================

    componentDidMount() {

        const username =  this.getRememberedUser();   
        const password =  this.getRememberedPassword();       
         // console.log(username);          
        this.setState({           
             mobile: username || "",      
             password: password || "", 
            rememberMechk: username && password ? true : false 
        });
        let temp = this;

        let userStr = localStorage.getItem('usr');
        let passwordStr = localStorage.getItem('pas');
        let expiryDate = localStorage.getItem('expiryDate');

        var result = new Date();
        result.setDate(result.getDate() + 10);
        console.log(result);


        console.log(expiryDate);
        if (expiryDate !== null) {
            let newExpiryDate = new Date(expiryDate)
            console.log(newExpiryDate);

            var todaysdate = new Date();
            var dateMatch = todaysdate.getDate() === newExpiryDate.getDate();
            console.log(dateMatch);
            if (dateMatch === true) {
                localStorage.clear();
            }
        }

        // console.log(user,password);
        if (userStr !== null && passwordStr !== null) {

            // Decrypt
            var userdec = CryptoJS.AES.decrypt(userStr, '12345');
            var userorg = userdec.toString(CryptoJS.enc.Utf8);

            var passdec = CryptoJS.AES.decrypt(passwordStr, '12345');
            var passorg = passdec.toString(CryptoJS.enc.Utf8);

            console.log(userorg, passorg); // Original Username/Password

            this.setState({
                signLoader: true
            }, () => {
                setTimeout(function () {
                    temp.props.history.push('/principal');
                }, 1000);
                // this.props.history.push('/principal');
            })

        }
    }

    render() {
        const signLoader = this.state.signLoader
        console.log(signLoader);
        return (
            <FormLayout>

                <Spin tip="Auto Signing In..." style={{ display: signLoader === false ? 'none' : '' }}>

                </Spin>


                <Form style={{ display: signLoader === false ? '' : 'none' }}>
                    <span style={{ fontSize: "14px", marginBottom: "10px", display: "block" }}>
                        <AppNavbarBrand full={{ src: logo, width: 200, height: 80, alt: 'CoreUI Logo' }} />
                    </span>
                    <h3>Dashboard Login</h3>
                    <p className="text-muted">Sign In to your account</p>
                    <Row>
                        <Col xs="2"></Col>
                        <Col xs="8">
                            <InputGroup className="mb-3">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="icon-user"></i>
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    type="text"
                                    name="mobile"
                                    placeholder="Enter Mobile Number"
                                    value={this.state.mobile}
                                    onChange={this.onUpdateFormValue}
                                    onKeyPress={this.onKeyDown}
                                // invalid={this.state.mobile === ""}
                                />
                                <FormFeedback>Mobile Number is required</FormFeedback>
                            </InputGroup>
                            <InputGroup className="mb-4" >
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="icon-lock"></i>
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    value={this.state.password}
                                    onChange={this.onUpdateFormValue}
                                    onKeyPress={this.onKeyDown}
                                // invalid={this.state.password === ""}
                                />
                                <FormFeedback>Password is required</FormFeedback>
                            </InputGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="2"></Col>
                        <Col xs="6">
                            <Checkbox 
                              onChange={this.onRememberChk}
                              checked={this.state.rememberMechk}
                              disabled={this.state.mobile === '' || this.state.password === '' }
                            >Remember Me</Checkbox>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs="3">
                        </Col>
                        <Col xs="6">
                            <Button color="primary" className="px-4 w-100" onClick={this.login}>Login</Button>
                        </Col>
                    </Row>
                </Form>
            </FormLayout>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAlert()(Login));
